import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ModalsContext } from '../../contexts/ModalsContext';
import { AlertContext } from '../../contexts/AlertContext';
import { SocketContext } from '../../contexts/SocketContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import { CreateSurveyForm } from '../../components/surveys/surveys/CreateSurveyForm';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { Actions } from '../../components/surveys/surveys/Actions';
import { useModalStore } from '../../store/useModalStore';

const columns = [
    { id: "titulo", label: "Encuesta", minWidth: 170, align: 'center' },
    { id: "usuario", label: "Evaluado", minWidth: 170, align: 'center' },
    { id: "canal", label: "Canal", minWidth: 170, align: 'center' },
    { id: "sede", label: "Sede", minWidth: 170, align: 'center' },
    { id: "estado", label: "Estado", minWidth: 170, align: 'center' },
    { id: "acciones", label: "Acciones", minWidth: 170, align: 'center' }
];

export const useSurveys = () => {

    const [surveys, setSurveys] = useState([]);

    // const { modalRef } = useContext(ModalsContext);
    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { openModal, closeModal } = useModalStore();

    useEffect(() => {
        let subscribed = true;
        
        if(subscribed) 
            setOpenLoader(true);
            getSurveys();

        return () => subscribed = false;
    }, []);

    const searchSurvey = (value) => { 
        socket.emit('frontend:buscar-encuesta', { codigo: value?.trim() }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                alertRef.current?.handleOpen('error', message);
                return;
            }
          
            setSurveys(data?.map(s => generatePayload(s)));
        });
    }

    const generateQR = (_id) => {
        return new Promise((resolve, reject) => {
            setOpenLoader(true);
            socket.emit('frontend:generar-qr', { _id }, response => {
                const { ok, message, data } = response;
    
                if(!ok) {
                    setOpenLoader(false);
                    // modalRef.current?.handleClose();
                    closeModal();
                    alertRef.current?.handleOpen('error', message);
                    reject(false);
                    return;
                }
    
                setSurveys(prev => prev?.map(p => p?._id === _id ? generatePayload(data) : p ));
                setOpenLoader(false);
                resolve(data?.qr?.url);
            });
        });
    }

    // const addSurvey = () => {
    //     modalRef.current.handleOpen(<CreateSurveyForm action={ (data) => saveSurvey(data)  } />, 'auto', 'auto');
    // }

    const addSurvey = () => openModal(<CreateSurveyForm action={ (data) => saveSurvey(data)  } />);

    const saveSurvey = (args) => {
        setOpenLoader(true);
        const{ titulo, introduccion, codigo, canal, sede, area, usuario, introduccion_servicios, servicios, preguntas } = args;
        socket.emit('frontend:crear-encuesta', { 
            titulo: titulo?.trim(),
            introduccion: introduccion?.trim(),
            codigo: codigo.toLowerCase().trim(),
            canal,
            sede,
            area,
            usuario,
            introduccion_servicios: introduccion_servicios?.trim(),
            servicios,
            preguntas
        }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setSurveys(prev => ([...prev, generatePayload(data)]));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const getSurveys = useCallback(() => {
        socket.emit('frontend:obtener-encuestas', (response) => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }
           
            const newArr = data?.map(generatePayload);
            setSurveys(newArr);
            setOpenLoader(false);
        });
    }, []);

    const updateSurvey = (args) => {
        setOpenLoader(true);
        const{ _id, titulo, introduccion, canal, sede, area, usuario, introduccion_servicios, servicios, preguntas, activo } = args;
        socket.emit('frontend:actualizar-encuesta', { 
            _id, 
            titulo: titulo?.trim(),
            introduccion: introduccion?.trim(),
            canal,
            sede,
            area,
            usuario,
            introduccion_servicios: introduccion_servicios?.trim(),
            servicios,
            preguntas,
            activo: Boolean(activo) 
        }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }
            
            setSurveys(prev => prev?.map(p => p?._id === _id ? generatePayload(data) : p ));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const duplicateSurvey = (args) => {
        setOpenLoader(true);
        const{ titulo, activo, introduccion, codigo, canal, sede, area, usuario, introduccion_servicios, servicios, preguntas } = args;
        socket.emit('frontend:duplicar-encuesta', { 
            titulo: titulo?.trim(),
            activo: Boolean(activo),
            introduccion: introduccion?.trim(),
            codigo: codigo.toLowerCase().trim(),
            canal,
            sede,
            area,
            usuario,
            introduccion_servicios: introduccion_servicios?.trim(),
            servicios,
            preguntas
        }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setSurveys(prev => ([...prev, generatePayload(data)]));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const deleteSurvey = (_id) => {
        setOpenLoader(true);
        socket.emit('frontend:eliminar-encuesta', { _id }, response => {
            const { ok, message } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setSurveys(prev => prev?.filter(p => p._id !== _id));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const generatePayload = (data) => ({
        ...data,
        titulo: (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>{ convertirLetraMayus(data?.titulo) }</span>
                <span style={{ fontSize: 12, fontWeight: 600 }}>{ convertirLetraMayus(data?.codigo) }</span>
            </div>
        ),
        usuario: data?.usuario ? convertirLetraMayus(data?.usuario.nombre, true) : 'N/A',
        canal: convertirLetraMayus(data?.canal.canal),
        sede: convertirLetraMayus(data?.sede?.nombre),
        estado: data?.activo ? 'Activo' : 'Inactivo',
        acciones: <Actions data={ data } qr={ generateQR } updated={ updateSurvey } duplicated={ duplicateSurvey } deleted={ deleteSurvey } />
    });

    return {
        columns,
        surveys,
        addSurvey,
        searchSurvey
    }
}